// @flow
/** @jsx h */

import { h } from 'preact'

import styles from './ResultItem.css'
import { getScorePercent } from '../../helpers/getScorePercent'
import { Bar } from './components/Bar/Bar'
import { Percent } from './components/Percent/Percent'
import { Number } from './components/Number/Number'
import type { ResultItem as ResultItemType } from '../../../../../../types'

type Props = {
  isSlim: boolean,
  resultItem: ResultItemType,
  showNumber: boolean,
  scorePercent: number,
  relativeScorePercent: number,
  isHighlighted?: boolean
}

type ScreenReaderListProps = {
  items: ResultItemType[],
  totalVotes: number
}

export const ScreenReaderList = (props: ScreenReaderListProps) => {
  const { items, totalVotes } = props

  return <ul class={styles['resultList__sr']}>
    {items.map(resultItem => (
      <ScreenReaderItem
        resultItem={resultItem}
        scorePercent={getScorePercent(resultItem.votes, totalVotes)}
      />
    ))}
  </ul>
}

type BarListProps = {
  items: ResultItemType[],
  totalVotes: number,
  isSlim: boolean,
  showNumber: boolean,
  highlightedId: number
}

export const BarList = (props: BarListProps) => {
  const { items, isSlim, showNumber, totalVotes, highlightedId } = props
  return <div aria-hidden class={styles['resultList__bars']}>
    {items.map(resultItem => (
      <BarItem
        isSlim={isSlim}
        showNumber={showNumber}
        scorePercent={getScorePercent(resultItem.votes, totalVotes)}
        resultItem={resultItem}
        isHighlighted={shouldHighlight(resultItem, highlightedId)}
      />
    ))}
  </div>
}

type TextListProps = {
  items: ResultItemType[],
  totalVotes: number,
  isSlim: boolean,
  showNumber: boolean,
  highlightedId: number
}

export const TextList = (props: TextListProps) => {
  const { items, isSlim, showNumber, totalVotes, highlightedId } = props

  return (
    <div aria-hidden class={styles['resultList__text']}>
      {items.map(resultItem => (
        <TextItem
          isSlim={isSlim}
          showNumber={showNumber}
          scorePercent={getScorePercent(resultItem.votes, totalVotes)}
          resultItem={resultItem}
          isHighlighted={shouldHighlight(resultItem, highlightedId)}
        />
      ))}
    </div>
  )
}

export const BarItem = (props: Props) => {
  const { resultItem, scorePercent, isHighlighted, isSlim } = props
  return (
    <div aria-hidden='true'
      className={styles['resultItem']}
      data-alternativeid={resultItem.id}
    >
      <div className={styles.resultItem__label}>{resultItem.text}</div>
      <div className={styles['resultItem__score-wrapper']}>
        <Bar
          width={scorePercent}
          isHighlighted={isHighlighted}
          isSlim={isSlim}
        />

      </div>
    </div>
  )
}

export const TextItem = (props: Props) => {
  const { resultItem, scorePercent, showNumber } = props
  return <div class={styles['resultItem__score-text-wrapper']}>
    <Number hidden={!showNumber} value={resultItem.votes || 0} />
    <Percent hidden={showNumber} scorePercent={scorePercent} />
  </div>
}

export const ScreenReaderItem = ({ resultItem, scorePercent }: { resultItem: ResultItemType, scorePercent: number }) => {
  return <li className='nrk-sr'>
    {getTextRepresentation(resultItem, scorePercent)}
  </li>
}

function shouldHighlight (
  resultItem: ResultItemType,
  highlightedId?: ?number
): boolean {
  if (!highlightedId) {
    return false
  }
  return resultItem.id === highlightedId
}

function getTextRepresentation (
  resultItem: ResultItemType,
  scorePercent: number
): string {
  const formattedScorePercent = (scorePercent || 0).toFixed(1).replace('.', ',')
  return `Alternativ ${
    resultItem.text
  } har fått ${formattedScorePercent}% av stemmene`
}



// WEBPACK FOOTER //
// ./src/shared/components/Result/components/ResultList/components/ResultItem/ResultItem.js